import createNamedContext from 'utils/createNamedContext';
import * as React from 'react';
import {
  Steps,
  BasicCircle,
  AdvancedCircle,
  AiModelCircle,
  MarketingCircle,
  AiAssistantBotCircle,
  AiSaleBotCircle,
  AiSaleBotAdvancedCircle,
} from '../consts/step';

type CircleContextProps = {
  circle: Steps[];
  endRouter: string;
  type:
    | 'basic'
    | 'ai_model'
    | 'advanced'
    | 'marketing'
    | 'aiSaleBot'
    | 'aiAssistantBot'
    | 'aiSaleBotAdvanced';
  setCircle: React.Dispatch<React.SetStateAction<Steps[]>>;
};

const CircleContext = createNamedContext<CircleContextProps>('CirCleContext', null!);

export const useCirCleContext = () => {
  const context = React.useContext(CircleContext);
  if (!context) {
    throw new Error('useCirCleContext must be used within a CirCleProvider');
  }
  return context;
};

export const CirCleProvider = (
  props: { children: React.ReactNode } & Pick<CircleContextProps, 'type'>,
) => {
  const { children, type } = props;
  const [circle, setCircle] = React.useState(
    {
      basic: BasicCircle,
      ai_model: AiModelCircle,
      advanced: AdvancedCircle,
      marketing: MarketingCircle,
      aiSaleBot: AiSaleBotCircle,
      aiAssistantBot: AiAssistantBotCircle,
      aiSaleBotAdvanced: AiSaleBotAdvancedCircle,
    }[type],
  );

  const endRouter = `/bootguide/${type}/end`;

  return (
    <CircleContext.Provider value={{ circle, endRouter, type, setCircle }}>
      {children}
    </CircleContext.Provider>
  );
};
